export default "<p>edit-payment-mode works!</p>\r\n"